export class TooltipActivatorNotProvidedError extends Error {
  constructor() {
    super('Tooltip activator is not provided')
  }
}
